import axios from './index';

// V1: Deprecated
export const _getAllClients = () => {
  return axios.get(`public/v1/app/get-customer`);
};

export const getAllClientsRequest = (filterObj = {}) => {
  const { issuerID, categoryID } = filterObj;
  return axios.get(
    `v1/admins/issuers/get/issuers/${issuerID || '-'}/${categoryID || '-'}/-/-`
  );
};

export const toggleClientStatusRequest = (id, payload) =>
  axios.put(`v1/admins/issuers/toggle/issuer/${id}/access-status`, payload);

export const getAllClientsStaffRequest = (filterObj = {}) => {
  const { issuerID, issuerStaffID } = filterObj;
  return axios.get(
    `v1/admins/issuer-staffs/get/issuer-staffs/${issuerStaffID || '-'}/${
      issuerID || '-'
    }/-/-`
  );
};

export const toggleClientStaffStatusRequest = (id, payload) =>
  axios.put(
    `v1/admins/issuer-staffs/toggle/issuer-staff/${id}/access-status`,
    payload
  );

export const resetClientStaffPasswordRequest = (filterObj) => {
  const { issuerStaffID } = filterObj;
  return axios.put(
    `v1/admins/issuer-staffs/reset/issuer-staff/password/${issuerStaffID}`
  );
};

export const getAllIssuerClientsStaffRequest = (filterObj = {}) => {
  return axios.get(`v1/issuer-staffs/get/issuer-staffs/-/-/-`);
};

export const logoutClientStaffRequest = (filterObj) => {
  const { issuerStaffID } = filterObj;
  return axios.post(
    `v1/admins/issuer-staffs/logout/issuer-staff/${issuerStaffID}`
  );
};
